import LocalStorage from '../../../Services/LocalStorage';

export const doNotShowHintAgain = (key: string) => {
	LocalStorage.set(key, true);
};

export const getShouldBeHintDisplayed = (key: string) => {
	return !LocalStorage.get(key);
};
